module.exports = __webpack_public_path__ + "820f562ac1cca51fa4fbd36d5cd617ef.jpg";